import React, { FC } from "react";

import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import { stopEvents } from "@mapmycustomers/shared/util/browser";
import { Button } from "@mapmycustomers/ui";

import styles from "./CollapseExpandButton.module.scss";

export interface CollapseExpandButtonProps {
  className?: string;
  fixed?: boolean;
  onToggle?: (collapsed: boolean) => void;
}

const CollapseExpandButton: FC<CollapseExpandButtonProps> = ({ className, fixed, onToggle }) => {
  const intl = useIntl();

  return (
    <Tooltip
      placement="right"
      title={intl.formatMessage(
        {
          id: "dashboard.sidebar.expandCollapse",
          defaultMessage: "{expanded, select, true {Collapse} other {Expand}}",
          description: "Expand/collapse dashboard sidebar button tooltip",
        },
        { expanded: fixed }
      )}
    >
      <Button
        className={cn(styles.container, className)}
        icon={<FontAwesomeIcon icon={faChevronLeft} rotation={fixed ? undefined : 180} />}
        iconOnly
        onClick={() => onToggle?.(!fixed)}
        onMouseOver={stopEvents} // need this to prevent onMouseOver triggering over collapsed sidebar
        type="filled"
      />
    </Tooltip>
  );
};

export default CollapseExpandButton;
